import { useState } from "react";
import Config from "../../Config";
import Start from "./Start";
import Clients from "./Clients";
import Contracts from "./Contracts";
import Services from "./Services";
import Locks from "./Locks";




function HomeView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


  
    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }



    if(props.mainView.viewSelected == 'start')
    {
        document.title ="Start"; 
        return (
            <div className="econtent ">                                  
                  <Start  userData={props.userData}  mainView={props.mainView}  keyListener={props.keyListener} />
            </div>
        )
    }


      if(props.mainView.viewSelected == 'clients')
    {
        document.title ="Baza klientów"; 
        return (
            <div className="econtent ">                                  
                  <Clients  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}  />
            </div>
        )
    }


    if(props.mainView.viewSelected == 'contracts')
    {
        document.title ="Umowy"; 
        return (
            <div className="econtent ">                                  
                  <Contracts  userData={props.userData}  mainView={props.mainView}  keyListener={props.keyListener} />
            </div>
        )
    }


      if(props.mainView.viewSelected == 'services')
    {
        document.title ="Usługi"; 
        return (
            <div className="econtent ">                                  
                  <Services
                    userData={props.userData}  mainView={props.mainView}  keyListener={props.keyListener}  />
            </div>
        )
    }


      if(props.mainView.viewSelected == 'locks')
    {
        document.title ="Blokady"; 
        return (
            <div className="econtent ">                                  
                  <Locks
                    userData={props.userData}  mainView={props.mainView}  keyListener={props.keyListener}  />
            </div>
        )
    }


        return (
        <div className="econtent ">
             HomeView - no selected menu position
        </div>
    );
}


export default HomeView ;